/** The last question before an account is merged into the one being viewed and deleted. */
export const mergeUsersConfirmMessage = (sourceName: string) => (
  <span>
    Сигурни ли сте, че искате да слеете <b>{sourceName}</b> в този акаунт?
    Акаунтът на {sourceName} ще бъде изтрит. Това действие е необратимо.
  </span>
);
